
import Vue, { PropType } from 'vue';
import { Runnit, RunnitNode } from '@run-diffusion/shared';
import { mapActions, mapGetters, mapState } from 'vuex';
import { PORTAL_LOCATION } from '@/views/Runnits/constants';
import RunnitSettingsDrawer from '@/views/Runnits/RunnitSettingsDrawer.vue';
import { MyBalanceMixin, RunnitRemixMixin, TeamUserMixin } from '@/mixins';
import { RunnitsImageSelectMixin } from '@/mixins/RunnitsImageSelectMixin';
import ActionsIslandFixedBottom from '@/components/ActionsIslandFixedBottom.vue';
import BaseButton from '@/components/base/BaseButton.vue';
import { PortalTarget } from 'portal-vue';
import moment from 'moment';

export default Vue.extend({
	name: 'RunnitTraining',
	metaInfo () {
		return {
			title: this.currentRunnit ? this.currentRunnit.title : 'Loading...',
		};
	},
	props: {
		currentRunnit: {
			type: Object as PropType<Runnit>,
			required: true,
		},
	},
	data () {
		return {
			// Freeze static objects to prevent unnecessary reactivity
			PORTAL_LOCATION: Object.freeze(PORTAL_LOCATION),

			runnitNodesLoading: true,
		};
	},
	mixins: [
		RunnitsImageSelectMixin,
		TeamUserMixin,
		MyBalanceMixin,
		RunnitRemixMixin,
	],
	computed: {
		...mapState([
			'user',
			'runnitState',
			'runnitNodes',
			'runnitNodesMap',
		]),
		...mapGetters([
			'runnitNodesLimitMap',
		]),
		selectedNode () {
			return this.runnitState.selectedNodeId ? this.runnitNodesMap[this.runnitState.selectedNodeId] : null;
		},
		computedActionIslandWidth () {
			const bp = this.$vuetify.breakpoint;
			if (bp.smOnly) return '60%';
			if (bp.mdOnly) return '45%';
			if (bp.lgAndUp) return '35%';
			return '96.5%';
		},
	},
	watch: {
		'$route.query.inputValues': {
			immediate: true,
			handler (newVal) {
				if (newVal) {
					if (!this.runnitState.runnit) {
						setTimeout(() => {
							if (this.runnitNodes?.length) {
								this.onSelectNode(this.runnitNodes[0].id);
							}
						}, 500);
					}
					if (this.runnitNodes?.length) {
						this.onSelectNode(this.runnitNodes[0].id);
					}
				}
			},
		},

		runnitNodes: {
			immediate: true,
			handler (newVal: RunnitNode[], oldVal: RunnitNode[]) {
				if (
					newVal &&
					newVal.length &&
					this.$vuetify.breakpoint.mdAndUp &&
					!this.runnitState.selectedNodeId
				) {
					this.onSelectNode(newVal[0].id);
				} else if (!newVal?.length && oldVal?.length) {
					this.onSelectNode(null);
				}

				setTimeout(() => {
					this.runnitNodesLoading = false;
					if (this.runnitNodes.length) {
						this.onSelectNode(this.runnitNodes[0].id);
					}
					if (this.runnitNodes.length > 1) {
						console.error('A single tool has multiple nodes');
					}
				}, 500);
			},
		},
		selectedNode: {
			immediate: true,
			handler (newVal: RunnitNode) {
				const newNodeDefTitle = newVal?.nodeDef?.title;
				const currentToolName = this.$route.query.toolName;
				if (newNodeDefTitle && currentToolName !== newNodeDefTitle) {
					this.$router.replace({
						...this.$route,
						query: {
							...this.$route.query,
							toolName: newNodeDefTitle,
						},
					});
				}
			},
		},
	},
	methods: {
		moment,
		...mapActions([
			'updateSnackbar',
			'updateRunnitState',
			'setUpsellDialog',
		]),
		onSelectNode (nodeId: string) {
			this.updateRunnitState({
				selectedNodeId: nodeId,
				settingsDrawerOpen: !!nodeId,
			});
		},
		setSettingsDrawerOpen (isOpen: boolean) {
			this.updateRunnitState({
				settingsDrawerOpen: isOpen,
				...(!isOpen && {
					imageGalleryDialogOpen: false,
					promptGeneratorOpen: false,
					imageSelectOpen: false,
					inpaintingEditorOpen: false,
				}),
			});
		},
	},
	components: {
		RunnitSettingsDrawer,
		ActionsIslandFixedBottom,
		BaseButton,
		PortalTarget,
	},
});
